import axios from 'utils/axios';

class NotificationService {
  getAllNotifications(team_id, page = 1) {
    return axios.get('user/notifications', {
      params: {
        team_id,
        page
      }
    });
  }

  getAllNotificationsByTeam(team_id, page = 1) {
    return axios.get('user/notifications', {
      params: {
        team_id,
        page,
      }
    });
  }

  getReadNotification(notification_id) {
    return axios.get(`user/notifications/${notification_id}`);
  }

  getUnReadNotifications() {
    return axios.get('user/notifications/unread');
  }

  async getRecentNotificationsCount() {
    try {
      const response = await axios.get('user/notifications/recent-notifications-count');

      return response.data.data.notifications_count;
    } catch (error) {
      Promise.resolve(0);
    }
  }
}

export default new NotificationService();
